// iOS web-view 中 el-select 点击需要双击的问题修复指令
// 用法：在 main.js 中 import IosSelectFix from '@/directives/iosSelectFix' ; Vue.use(IosSelectFix)

export default {
  install(Vue) {
    Vue.directive('ios-select-fix', {
      inserted(el) {
        // 使用 MutationObserver 监听下拉内容的插入（Element UI 的下拉一般被 append 到 body）
        try {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach(() => {
              // 查询所有下拉项（全局查询更可靠，因为 popper 可能在 body 下）
              const options = document.querySelectorAll('.el-select-dropdown__item');
              if (!options || !options.length) return;
              options.forEach(option => {
                // 防止重复绑定
                if (option.__iosSelectBound) return;
                option.__iosSelectBound = true;

                // 绑定 touchend，模拟 click，避免 iOS webview 中需要两次触发的问题
                const handler = function (e) {
                  try {
                    e.stopPropagation();
                    e.preventDefault();
                    const clickEvent = new MouseEvent('click', {
                      bubbles: true,
                      cancelable: true,
                      view: window
                    });
                    option.dispatchEvent(clickEvent);

                    // 可选：尝试手动关闭当前下拉（Element UI 的 popper 结构可能不同）
                    const popper = document.querySelector('.el-select-dropdown');
                    if (popper) popper.style.display = 'none';
                  } catch (err) {
                    // swallow
                  }
                };

                option.__iosSelectHandler = handler;
                option.addEventListener('touchend', handler, false);
              });
            });
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });

          // 保存 observer 以便在 unbind 时清理
          el.__iosSelectObserver = observer;
        } catch (err) {
          // 不支持 MutationObserver 的环境直接忽略
        }
      },
      unbind(el) {
        try {
          if (el.__iosSelectObserver) {
            el.__iosSelectObserver.disconnect();
            delete el.__iosSelectObserver;
          }

          // 移除已绑定到下拉项的 touchend 处理器
          const options = document.querySelectorAll('.el-select-dropdown__item');
          options.forEach(option => {
            if (option.__iosSelectHandler) {
              option.removeEventListener('touchend', option.__iosSelectHandler, false);
              delete option.__iosSelectHandler;
            }
            if (option.__iosSelectBound) delete option.__iosSelectBound;
          });
        } catch (err) {
          // ignore
        }
      }
    });
  }
};
